import React from "react";
import SEO from "@/components/SEO";
import Header from "@/components/mikassa/Header";
import Hero from "@/components/mikassa/Hero";
import Philosophy from "@/components/mikassa/Philosophy";
import Vision2035 from "@/components/mikassa/Vision2035";
import Ecosystem from "@/components/mikassa/Ecosystem";
import PolesMap from "@/components/mikassa/PolesMap";
import Flagship from "@/components/mikassa/Flagship";
import Configurator from "@/components/mikassa/Configurator";
import Synergies from "@/components/mikassa/Synergies";
import Blog from "@/components/mikassa/Blog";
import ContactForm from "@/components/mikassa/ContactForm";
import Footer from "@/components/mikassa/Footer";

// FAQ data for schema markup
const FAQ_DATA = [
  {
    question: "Qu'est-ce que Mikassa Agency ?",
    answer: "Mikassa Agency est un logiciel de gestion locative conçu pour les propriétaires et agences immobilières en Afrique. Il permet de gérer les biens, les locataires, les loyers et les contrats depuis une seule plateforme."
  },
  {
    question: "Comment Mikassa réduit-il les impayés ?",
    answer: "Mikassa envoie des rappels automatiques par SMS avant et après l'échéance du loyer, intègre le paiement Mobile Money (Orange Money, MTN) pour faciliter les paiements, et permet un suivi en temps réel des paiements avec alertes visuelles."
  },
  {
    question: "Mikassa fonctionne-t-il avec Mobile Money ?",
    answer: "Oui, Mikassa intègre Orange Money et MTN Mobile Money. Les locataires peuvent payer leur loyer directement depuis leur téléphone, et les quittances sont générées automatiquement."
  },
  {
    question: "Combien coûte Mikassa Agency ?",
    answer: "Mikassa propose un essai gratuit de 14 jours. Les forfaits commencent à 5 000 FCFA/mois pour jusqu'à 5 biens, 15 000 FCFA/mois pour 20 biens, et 35 000 FCFA/mois pour un nombre illimité de biens."
  },
  {
    question: "Dans quels pays Mikassa est-il disponible ?",
    answer: "Mikassa est disponible en Côte d'Ivoire, au Sénégal, au Mali, au Burkina Faso, et s'étend progressivement à toute l'Afrique de l'Ouest francophone. Le support en anglais est disponible pour le Ghana et le Nigeria."
  }
];

// Review data for schema markup
const REVIEW_DATA = [
  {
    author: "Kouamé Jean",
    body: "Avant Mikassa Agency, je passais mes weekends à calculer les loyers et envoyer des rappels. Maintenant, tout est automatique. J'ai récupéré ma vie de famille.",
    rating: "5",
    date: "2024-02-15"
  },
  {
    author: "Diallo Marie",
    body: "Les rappels SMS automatiques ont transformé notre relation avec les locataires. Ils paient à temps car ils reçoivent des rappels avant l'échéance, pas après. 90% d'impayés en moins.",
    rating: "5",
    date: "2024-01-20"
  },
  {
    author: "Agence Prestige Immo",
    body: "Grâce à Mikassa Agency, notre agence a pu tripler notre portefeuille sans embaucher. L'automatisation nous permet de gérer plus avec la même équipe.",
    rating: "5",
    date: "2024-03-01"
  }
];

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF8] text-[#2D3436]">
      <SEO
        title="Gestion Locative Simplifiée"
        description="Mikassa Agency — Logiciel de gestion locative pour l'Afrique. Gérez vos biens, locataires et paiements. Réduisez les impayés de 90% et gagnez 70% de temps."
        url="/"
        faqs={FAQ_DATA}
        reviews={REVIEW_DATA}
      />
      <Header />
      <main>
        <Hero />
        <Philosophy />
        <Vision2035 />
        <Ecosystem />
        <PolesMap />
        <Flagship />
        <Configurator />
        <Synergies />
        <Blog />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
